import { InfoCard, ChangeIPCard } from "./lecsOptions-components/components"
import Header from "../../../components/Header"
import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react"
import API from "../../../api"
import { ReactNotifications } from "react-notifications-component"
const LecsOptions = () => {

    const [lecsInfo, setLecsInfo] = useState({})

    useEffect(() => {
        API.getLecsInfoByReseller().then(res => {
            window.sessionStorage.setItem('tipoLecs', res.data.tipo )
            setLecsInfo(res.data)
        }).catch(err => {
            console.error('[LecsOptions] Failed to fetch LECS info:', err)
        })
    }, [])

    return (
        <Box m="20px">
            <Header title="LECS OPTIONS" />
            <ReactNotifications />
            {lecsInfo && 
            <Grid marginTop={1} container spacing={2}>
                <Grid size={12}>
                    <InfoCard lecsInfo={lecsInfo} />
                </Grid>
                <Grid size={12}>
                    <ChangeIPCard tipo={lecsInfo.tipo}/>
                </Grid>
            </Grid>
            }
        </Box>

    )
}

export default LecsOptions